<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="95%"
    @change="visibleChanged"
    no-header
    prop
  >
    <!-- <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    /> -->
    <confirm-modal
      :id.sync="confirmModel.id"
      :prms="confirmModel"
      @on-ok="promptOk"
      @on-prompt-cancel="confirmModel.id = 0"
    ></confirm-modal>
    <mention-users
      :show="mentionObj.show"
      :obj.sync="mentionObj"
      module="form"
      @on-force="showUserPermission()"
      @on-mention-close="mentionObj.show = false"
    ></mention-users>
    <permission-users
      :show="permissionObj.show"
      :obj.sync="permissionObj"
      module="form"
      @on-edit-close="permissionObj.show = false"
      @on-share="
        permissionObj.show = false;
        showMention();
      "
    ></permission-users>
    <div>
      <div class="content-header bd-b pd-0">
        <nav
          ref="detailMainNav"
          class="navbar navbar-expand-lg bg-primary-light wd-100p"
          style="height: 59px;"
        >
          <div class="dropdown">
            <a
              class="navbar-brand tx-bold tx-spacing--2 order-1"
              href="javascript:void(0)"
              data-toggle="dropdown"
            >
              <a
                class="btn- btn-info btn-uppercase pd-x-15 pd-t-10 pd-b-8 text-white mg-r-10 rounded-sm"
              >
                <feather type="menu" class="mg-r-5"></feather>Цэс
              </a>
              {{ moreData.title }}
              <feather type="chevron-down" class="wd-15 ht-15"></feather>
            </a>
            <div class="dropdown-menu tx-13">
              <a
                @click="menuClicked('edit')"
                class="dropdown-item"
                role="button"
                >Засах</a
              >
              <a
                @click="menuClicked('delete')"
                class="dropdown-item"
                role="button"
                >Архивлах</a
              >
              <a
                @click="menuClicked('share')"
                class="dropdown-item"
                role="button"
                >Хуваалцах</a
              >
              <a
                @click="menuClicked('permission')"
                class="dropdown-item"
                role="button"
                >Эрхийн тохиргоо</a
              >
              <a
                @click="menuClicked('result')"
                class="dropdown-item"
                role="button"
                >Статистик</a
              >
              <a
                @click="menuClicked('export')"
                class="dropdown-item"
                role="button"
                >Үр дүн экспортлох</a
              >
              <a
                @click="menuClicked('exportFormData')"
                v-if="hasPermission(['formimporter'])"
                class="dropdown-item"
                role="button"
                >Сан экспортлох</a
              >
              <a
                @click="menuClicked('printFormData')"
                v-if="hasPermission(['formimporter'])"
                class="dropdown-item"
                role="button"
                >Сан хэвлэх</a
              >
              <a
                @click="menuClicked('printFormData')"
                v-if="hasPermission(['formpublisher'])"
                class="dropdown-item"
                role="button"
                >Эмбед код авах</a
              >
              <a
                v-if="flag == 600"
                @click="menuClicked('shareMember')"
                class="dropdown-item"
                role="button"
                >Гишүүн удирдах</a
              >
              <a
                v-if="flag == 600"
                @click="menuClicked('showStat')"
                class="dropdown-item"
                role="button"
                >Үр дүн</a
              >
              <a
                @click="menuClicked('duplicateFormData')"
                class="dropdown-item"
                role="button"
                >Хуулбар үүсгэх</a
              >
              <a
                @click="menuClicked('testBank')"
                class="dropdown-item"
                role="button"
                >Санг турших</a
              >
            </div>
          </div>
          <button
            class="navbar-toggler order-2"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <feather type="menu" class="wd-20 ht-20"></feather>
          </button>

          <div
            class="collapse navbar-collapse order-2"
            id="navbarSupportedContent"
          >
            <button
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
              @click="visibleChanged(false)"
            >
              <feather type="x" class="feather wt-15 ht-15 pd-r-5"></feather
              >Хаах
            </button>
          </div>
        </nav>
      </div>
      <p v-if="!fetched"></p>
      <div v-else class="content-body pd-x-0 pd-y-0">
        <div class="container-fluid pd-x-0">
          <div class="d-flex" style="height: calc(100vh - 60px)">
            <div class="bd-r wd-15p">
              <div>
                <div class="pd-10 bg-white">
                  <button
                    class="btn btn-outline-light btn-xs btn-block"
                    @click="editSection({ id: 0 })"
                  >
                    <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Бүлэг
                    үүсгэх
                  </button>
                </div>
                <div class="pd-10 bd-t">
                  <label
                    class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                    >Бүлгүүд ({{ moreData.sectionData.count }})</label
                  >
                  <nav
                    class="nav nav-sidebar tx-13"
                    v-if="moreData.sectionData.count > 0"
                  >
                    <a
                      @click="editSection(q)"
                      class="nav-link"
                      v-for="(q, i) in sectionObj.list"
                      :key="i"
                      role="button"
                    >
                      <i
                        :class="
                          `icon ion-${
                            q.id == questionId
                              ? 'md-arrow-forward'
                              : 'md-folder'
                          } tx-16`
                        "
                      ></i>
                      <div class="mg-l-5">
                        <span>{{ q.name }}</span>
                      </div>
                    </a>
                  </nav>
                </div>
              </div>
            </div>
            <div class="bd-r wd-15p">
              <div>
                <div class="pd-10 bg-white">
                  <button
                    class="btn btn-outline-light btn-xs btn-block"
                    @click="editQuestion(0)"
                  >
                    <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Асуулт
                    үүсгэх
                  </button>
                </div>
                <vue-custom-scrollbar
                  class="pd-10 bd-t"
                  style="overflow: hidden; position: relative; height: calc(100vh - 133px);"
                >
                  <!-- TODO: ene hesgiig yanzlah -->
                  <label
                    class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                    >Асуултууд ({{ moreData.questionData.count }})</label
                  >
                  <nav
                    class="nav nav-sidebar tx-13"
                    v-if="moreData.questionData.questions.length > 0"
                  >
                    <a
                      @click="showAnswers(q.id, 1)"
                      class="nav-link"
                      v-for="(q, i) in moreData.questionData.questions"
                      :key="i"
                      role="button"
                      :class="{ active: q.id == questionId }"
                      :style="{ color: getColor(q) }"
                    >
                      <!-- <i
                        :class="`icon ion-${q.id==questionId?'md-arrow-forward':'md-clipboard'} tx-16`"
                      ></i> -->
                      {{ i + 1 }}).
                      <div class="mg-l-5">
                        <span v-html="q.question"></span>
                      </div>
                      <span class="badge badge-secondary text-white">{{
                        q.formAnswerData.length
                      }}</span>
                    </a>
                  </nav>
                  <div v-else class="d-flex" style="height: 86vh;">
                    <div class="ivu-col ivu-col-span-24">
                      <div
                        class="ivu-spin ivu-spin-large ivu-spin-fix ivu-spin-show-text"
                      >
                        <div
                          class="ivu-spin-main"
                          @click="editQuestion(0)"
                          role="button"
                        >
                          <img
                            src="assets/svg/nodata.svg"
                            style="width: 100%;"
                          />
                          <div class="text-muted">
                            Асуулт хоосон байна. энд дарж шинээр асуулт нэмнэ үү
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-custom-scrollbar>
                <b-modal
                  v-model="questionModel.show"
                  title="Асуулт"
                  scrollable
                  no-fade
                  centered
                  size="lg"
                >
                  <Form label-position="top" label-width="100%">
                    <template>
                      <FormItem label="Бүлэг сонгох">
                        <Select
                          v-model="questionModel.sectionId"
                          class="m-b-sm wd-100p"
                        >
                          <Option
                            :key="i"
                            v-for="(sctn, i) in sectionObj.list"
                            :value="sctn.id"
                            :label="sctn.name"
                            >{{ sctn.name }}</Option
                          >
                        </Select>
                      </FormItem>
                    </template>
                    <template v-if="!qtObj.hideQt">
                      <FormItem label="Асуултын төрөл">
                        <Select
                          v-model="questionModel.answerTypeId"
                          class="m-b-sm wd-100p"
                        >
                          <template v-for="(t, i) in questionTypes">
                            <Option
                              v-if="!t.disabled"
                              v-show="hasOneOf([flag], t.flag)"
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              >{{ t.label }}</Option
                            >
                            <Option
                              v-else
                              v-show="hasOneOf([flag], t.flag)"
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              disabled
                              >{{ t.label }}</Option
                            >
                          </template>
                        </Select>
                      </FormItem>
                      <FormItem
                        label="Асуултын хариултын харагдац"
                        v-if="
                          questionTypes.filter(
                            (x) => x.id == questionModel.answerTypeId
                          ).length > 0 &&
                            questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].questionViewTypes != undefined &&
                            questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].questionViewTypes.length > 0
                        "
                      >
                        <Select
                          v-model="questionModel.questionViewType"
                          class="m-b-sm wd-100p"
                        >
                          <template
                            v-for="(t, i) in questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].questionViewTypes"
                          >
                            <Option
                              v-if="!t.disabled"
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              >{{ t.label }}</Option
                            >
                            <Option
                              v-else
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              disabled
                              >{{ t.label }}</Option
                            >
                          </template>
                        </Select>
                      </FormItem>
                    </template>
                    <template v-if="flag == 900 || flag == 500">
                      <FormItem label="Төрөл">
                        <loc-type-cascader
                          v-model="selectedLocTypeId"
                          :getParentType="true"
                          :withUserId="
                            $store.state.user.groupId == 9235 || 
                            $store.state.user.groupId == 9362 ||
                            $store.state.user.groupId == 9368 ||
                            $store.state.user.groupId == 9351 ||
                            $store.state.user.groupId == 9363 ||
                            $store.state.user.groupId == 9290
                              ? $store.state.user.userId
                              : ''
                          "
                          locTypekey="formType"
                          @loctype-selected="locTypeChanged"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          Төрөл сонгоно уу.
                        </div>
                      </FormItem>

                      <FormItem label="Тестийн сан сонгох">
                        <Select
                          v-model="questionModel.libraryId"
                          class="m-b-sm"
                          filterable
                          clearable
                        >
                          <Option
                            v-for="f in libraries"
                            :value="f.id"
                            :key="f.id"
                            :label="
                              `${f.title} - ${f.questionData.count} асуулттай`
                            "
                          >
                            {{ f.title }} - {{ f.questionData.count }} асуулттай
                            <!-- <div style="float: right" class="text-muted">{{f.questionData.count}} асуулттай</div> -->
                          </Option>
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          Асуулт нэмэх тестийн сангаа сонгоно уу.
                        </div>
                      </FormItem>
                      <FormItem label="Асуултын тоо">
                        <InputNumber
                          v-model="questionModel.count"
                        ></InputNumber>
                        <div class="text-muted tx-11 eddt-title-info">
                          Дээр сонгосон сангаас шалгалтанд хэдэн асуулт
                          оруулахыг сонгоно уу.
                        </div>
                      </FormItem>
                      <FormItem label="Оноо">
                        <InputNumber
                          v-model="questionModel.point"
                        ></InputNumber>
                        <div class="text-muted tx-11 eddt-title-info">
                          Сонгосон сангаас сонгосон асуулт тус бүр хэдэн оноо
                          эзлэхийг оруулна уу.
                          <br />100 гэж оруулбал 1 оноо гэж үзнэ. 50 гэж
                          оруулбал 0,5 оноо гэж үзнэ. <br />Жишээ нь: тухайн
                          асуултууд 5 оноо эзлэх бол 500 гэж оруулна уу.
                        </div>
                      </FormItem>
                    </template>
                    <template v-if="!(flag == 900 || flag == 500)">
                      <FormItem label="Асуулт">
                        <Checkbox v-model="questionModel.editMode"
                          >HTML?</Checkbox
                        >
                        <textarea
                          v-if="!questionModel.editMode"
                          v-model="questionModel.question"
                          class="el-textarea__inner"
                        ></textarea>
                        <div v-else>
                          <div class="alert alert-info" role="alert">
                            <h4 class="alert-heading">Санамж</h4>
                            <p>
                              Бусад програмаас хуулахгүй доорхи талбарыг ашиглаж
                              засварлана уу
                            </p>
                          </div>
                          <summernote
                            v-model="questionModel.question"
                            :text="questionModel.question"
                            :key="questionKey"
                            class="m-t-sm m-b-sm"
                          ></summernote>
                        </div>
                      </FormItem>
                      <FormItem label="Файл" v-if="flag == 600 || flag == 800">
                        <simple-uploader
                          @on-success="fileUploadedSimple($event)"
                          :propBoxId="0"
                          :propObjectId="'0'"
                          :propObjectTypeId="6"
                          style="width:100%; max-width: 100%"
                        >
                          <div slot="trigger" class="wd-100p">
                            <a
                              v-if="
                                questionModel.attachmentId == 0 ||
                                  questionModel.attachmentId == null
                              "
                              class="dropdown-item"
                              >Компьютероос хуулах
                            </a>
                            <div v-else class="btn-group wd-100p">
                              <div
                                class="btn btn-outline-success"
                                @click.stop="
                                  showAttach(questionModel.attachmentId)
                                "
                              >
                                <feather type="eye"></feather>Файл харах
                              </div>
                              <div
                                class="btn btn-danger"
                                @click.prevent.stop="
                                  questionModel.attachmentId = null
                                "
                              >
                                <feather type="x"></feather>Салгах
                              </div>
                            </div>
                          </div>
                        </simple-uploader>
                      </FormItem>
                      <FormItem label="Тайлбар">
                        <Input v-model="questionModel.info" type="textarea" />
                      </FormItem>
                    </template>
                    <FormItem
                      label="Заавал"
                      v-if="
                        flag == 700 ||
                          (flag == 600 &&
                            (questionModel.answerTypeId == 1 ||
                              questionModel.answerTypeId == 3 ||
                              questionModel.answerTypeId == 4 ||
                              questionModel.answerTypeId == 7 ||
                              questionModel.answerTypeId == 11))
                      "
                    >
                      <Checkbox v-model="questionModel.isRequired"
                        >бөглөх ?</Checkbox
                      >
                      <input
                        v-if="questionModel.isRequired"
                        v-model="questionModel.requiredText"
                        class="el-input__inner"
                        placeholder="Бөглөөгүй орхисон тохиолдолд гарах санамж"
                      />
                      <div
                        class="alert alert-warning pd-y-0-f pd-x-5-f mg-t-5 tx-12 tx-italic"
                        role="alert"
                      >
                        Бөглөөгүй орхисон тохиолдолд гарах санамж
                      </div>
                    </FormItem>
                    <FormItem
                      label="Tip"
                      v-if="flag == 800 && questionModel.answerTypeId == 21"
                    >
                      <input
                        v-model="questionModel.tip"
                        class="el-input__inner"
                        placeholder="Хариулт оруулах үед гарна. ($, ¥, €) г.м"
                      />
                    </FormItem>
                    <FormItem
                      label="Сонголт"
                      v-if="
                        (flag == 600 && questionModel.answerTypeId == 3) ||
                          (flag == 800 && questionModel.answerTypeId == 7)
                      "
                    >
                      <div class="ivu-row-flex">
                        <div>
                          Хамгийн багадаа
                          <InputNumber
                            v-model="questionModel.linearMin"
                          ></InputNumber>
                        </div>
                        <div>
                          Хамгийн ихдээ
                          <InputNumber
                            v-model="questionModel.linearMax"
                          ></InputNumber>
                        </div>
                      </div>
                    </FormItem>
                    <FormItem label="Харгалзах утга" v-if="flag == 800">
                      <!-- 21 7 too
                      22 date-->
                      <DatePicker
                        v-if="questionModel.answerTypeId == 22"
                        v-model="questionModel.matchValue"
                        placeholder="Огноо сонгоно уу"
                        type="date"
                        style="width: 100%"
                        :format="'yyyy-MM-dd'"
                        :value-format="'yyyy-MM-dd'"
                      ></DatePicker>
                      <input
                        type="number"
                        class="el-input__inner"
                        v-else-if="
                          questionModel.answerTypeId == 7 ||
                            questionModel.answerTypeId == 21
                        "
                        v-model="questionModel.matchValue"
                      />
                      <input
                        v-else
                        v-model="questionModel.matchValue"
                        class="el-input__inner"
                        placeholder="Зөв хариултын утга"
                      />
                    </FormItem>
                    <template v-if="!qtObj.hideQt">
                      <FormItem
                        label="Хариултын харагдац"
                        v-if="
                          questionTypes.filter(
                            (x) => x.id == questionModel.answerTypeId
                          ).length > 0 &&
                            questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].answerViewTypes != undefined &&
                            questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].answerViewTypes.length > 0
                        "
                      >
                        <Select
                          v-model="questionModel.answerViewType"
                          class="m-b-sm wd-100p"
                        >
                          <template
                            v-for="(t, i) in questionTypes.filter(
                              (x) => x.id == questionModel.answerTypeId
                            )[0].answerViewTypes"
                          >
                            <Option
                              v-if="!t.disabled"
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              >{{ t.label }}</Option
                            >
                            <Option
                              v-else
                              :key="'pp_' + i"
                              :label="t.label"
                              :value="t.id"
                              disabled
                              >{{ t.label }}</Option
                            >
                          </template>
                        </Select>
                      </FormItem>
                    </template>
                  </Form>
                  <template #modal-footer>
                    <b-button
                      @click="chooseFromQuestionTemplate"
                      variant="info"
                      class="mg-r-auto"
                      >Асуултын загвараас сонгох</b-button
                    >
                    <b-button
                      @click="
                        questionModel.show = false;
                        clearQuestionModel();
                      "
                      variant="danger"
                      >Болих</b-button
                    >

                    <b-button
                      @click="postQuestionClone"
                      v-if="qtObj.hideQt"
                      class="btn btn-primary"
                      long
                      type="primary"
                    >
                      Хадгалах
                    </b-button>
                    <button
                      v-else
                      @click="postQuestion"
                      class="btn btn-primary"
                      long
                      type="primary"
                    >
                      Асуулт {{ questionModel.id == 0 ? "нэмэх" : "засах" }}
                    </button>
                    <!-- <b-button @click="onReset" variant="danger">Болих</b-button>
                    <b-button @click="onSubmit" variant="primary">Хадгалах</b-button>-->
                  </template>
                </b-modal>
              </div>
            </div>
            <div class="wd-55p pos-relative">
              <div
                :class="`ivu-col ivu-col-span-${flag == 600 ? '15' : '18'}`"
                v-if="questionId != 0"
              >
                <div class="bd-b pd-10 bg-white">
                  <div class="dropdown">
                    <a
                      class="navbar-brand tx-bold tx-spacing--2 order-1"
                      href="javascript:void(0)"
                      data-toggle="dropdown"
                    >
                      <a
                        class="btn- btn-info btn-uppercase pd-x-15 pd-t-10 pd-b-8 text-white mg-r-10 rounded-sm"
                      >
                        <feather type="menu" class="pd-r-5"></feather>цэс
                      </a>
                      Асуулт
                      <feather
                        type="chevron-down"
                        class="wd-15 ht-15"
                      ></feather>
                    </a>
                    <div class="dropdown-menu tx-13">
                      <a
                        @click="menuClickedQuestion('edit')"
                        class="dropdown-item"
                        role="button"
                        >Асуултыг Засах</a
                      >
                      <a
                        @click="menuClickedQuestion('delete')"
                        class="dropdown-item"
                        role="button"
                        >Асуултыг устгах</a
                      >
                      <a
                        @click="menuClickedQuestion('move')"
                        class="dropdown-item"
                        role="button"
                        >Асуултыг зөөх</a
                      >
                      <a
                        @click="menuClickedQuestion('template')"
                        class="dropdown-item"
                        role="button"
                        >Загвар болгох</a
                      >
                    </div>
                  </div>
                </div>
                <vue-custom-scrollbar
                  class="bd-t"
                  style="overflow: hidden;    position: relative; height: calc(100vh - 133px);"
                >
                  <template v-if="selectedQuestionData.answerTypeId == 6">
                    <div style="padding: 30px;">
                      <div>
                        <label
                          class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                          >Асуулт</label
                        >
                        <div
                          class="tx-color-02"
                          v-html="selectedQuestionData.question"
                        ></div>
                      </div>

                      <div class="alert alert-info" role="alert">
                        <h4 class="alert-heading">Санамж</h4>
                        <p>
                          Санамсаргүй сангаас асуулт сонгосон байна. Хариулт
                          оруулах боломжгүй.
                        </p>
                      </div>
                    </div>
                  </template>
                  <template
                    v-else-if="
                      selectedQuestionType.answer.mode == 1 ||
                        selectedQuestionType.answer.mode == 0
                    "
                  >
                    <div class="pd-x-20">
                      <div>
                        <label
                          class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                          >Асуулт</label
                        >
                        <h5
                          class="tx-color-02"
                          v-html="selectedQuestionData.question"
                        ></h5>
                      </div>
                      <div
                        v-show="
                          selectedQuestionData.answerTypeId == 7 ||
                            selectedQuestionData.answerTypeId == 21 ||
                            selectedQuestionData.answerTypeId == 22
                        "
                      >
                        <div>
                          <label
                            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                            >Харгалзах утга</label
                          >
                          <div>
                            <h6>
                              <span
                                v-if="
                                  selectedQuestionData.matchValue != null ||
                                    selectedQuestionData.matchValue != ''
                                "
                                >{{ selectedQuestionData.matchValue }}</span
                              >
                              <span v-else style="color:red"
                                >Зөв хариултын асуултын харгалзах утганд оноож
                                өгнө үү.</span
                              >
                            </h6>
                            <button
                              @click="menuClickedQuestion('edit')"
                              class="btn btn-xs btn-primary"
                            >
                              засах
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label
                          class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                          >Асуултын төрөл</label
                        >
                        <h6 class>
                          <span>{{
                            questionTypes.filter(
                              (x) => x.id == selectedQuestionData.answerTypeId
                            )[0].label
                          }}</span>
                        </h6>
                      </div>
                    </div>
                    <div
                      class="pd-10 bg-white bd-t"
                      v-if="
                        selectedQuestionType.answer.mode == 1 &&
                          selectedQuestionType.id != 34
                      "
                    >
                      <button
                        @click="editAnswer(0, 1)"
                        class="btn btn-outline-light btn-xs btn-block"
                      >
                        <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i>
                        Хариулт үүсгэх
                      </button>
                    </div>
                    <div
                      v-if="selectedQuestionType.answer.mode == 1"
                      class="c-l-r d-flex"
                      style="background: rgb(238, 238, 238) !important; border-top: 1px solid rgb(221, 221, 221); border-bottom: 1px solid rgb(221, 221, 221);"
                    >
                      <div
                        class="ivu-col ivu-col-span-1 pd-5 text-right text-muted wd-10p"
                      >
                        #
                      </div>
                      <div
                        class="ivu-col ivu-col-span-21 pd-5 wd-50p"
                        style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis"
                      >
                        Хариулт
                      </div>
                      <div
                        v-if="
                          selectedQuestionType.answer.list.group == 1 ||
                            selectedQuestionType.answer.list.group == 0
                        "
                        class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                        style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                      >
                        {{
                          selectedQuestionType.id == 41
                            ? "Багананы тоо"
                            : "Бүлэг"
                        }}
                      </div>
                      <div
                        v-if="
                          selectedQuestionType.answer.list.ord == 1 ||
                            selectedQuestionType.answer.list.ord == 0
                        "
                        class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                        style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                      >
                        {{
                          selectedQuestionType.id == 34
                            ? "харгалзах утга 1/2"
                            : selectedQuestionType.id == 41
                            ? "Мөрийн тоо"
                            : "Зөв дараалал"
                        }}
                      </div>
                      <div
                        v-if="
                          selectedQuestionType.answer.list.point == 1 ||
                            selectedQuestionType.answer.list.point == 0
                        "
                        class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                        style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                      >
                        Оноо
                      </div>
                      <div
                        class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                        style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                      >
                        Үйлдэл
                      </div>
                    </div>
                    <!-- <template
                      v-if="selectedQuestionData.answerTypeId == 7 || selectedQuestionData.answerTypeId == 21 || selectedQuestionData.answerTypeId == 22"
                    >
                    </template>
                    <template
                      v-else-if="selectedQuestionData.answerTypeId == 1 || selectedQuestionData.answerTypeId == 11"
                    >
                      <div class="ivu-col ivu-col-span-24 text-center pd-50" style="width:100%">
                        <div
                          class="text-muted"
                        >Хариултыг бичиж оруулах тул тохирох хариулт оруулах боломжгүй.</div>
                      </div>
                    </template>-->
                    <template
                      v-if="
                        selectedQuestionType.answer.mode == 1 &&
                          selectedQuestionData.formAnswerData.length > 0
                      "
                    >
                      <div
                        :style="{
                          background:
                            a.id == answerModel.id ? '#FFEB3B' : 'inherit',
                        }"
                        class="c-l-r ivu-row-flex d-flex bd-b"
                        v-for="(a, i) in selectedQuestionData.formAnswerData"
                        :key="i"
                        role="button"
                        @click="editAnswer(a)"
                      >
                        <div
                          class="ivu-col ivu-col-span-1 pd-5 text-right text-muted wd-10p"
                        >
                          {{ i + 1 }}
                        </div>
                        <div
                          class="ivu-col ivu-col-span-21 pd-5 wd-50p"
                          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis"
                        >
                          <div v-if="selectedQuestionType.id == 41">
                            файл харах
                          </div>
                          <div v-else>
                            {{ a.answer | stripHtml }}
                          </div>
                        </div>
                        <div
                          v-if="
                            selectedQuestionType.answer.list.group == 1 ||
                              selectedQuestionType.answer.list.group == 0
                          "
                          class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                        >
                          <span v-if="a.group > 0">{{ a.group }}</span>
                        </div>
                        <div
                          v-if="
                            selectedQuestionType.answer.list.ord == 1 ||
                              selectedQuestionType.answer.list.ord == 0
                          "
                          class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
                        >
                          <span v-if="a.ord > 0">{{ a.ord }}</span>
                        </div>
                        <div
                          v-if="
                            selectedQuestionType.answer.list.point == 1 ||
                              selectedQuestionType.answer.list.point == 0
                          "
                          class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; font-weight: 700"
                        >
                          <span v-if="a.mass > 0">{{ a.mass }}</span>
                        </div>
                        <div
                          class="ivu-col ivu-col-span-2 pd-5 wd-10p"
                          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; font-weight: 700"
                        >
                          <button
                            role="button"
                            type="button"
                            class="btn btn-outline-light btn-xs btn-icon"
                          >
                            <feather type="edit"></feather>
                          </button>
                          <button
                            type="button"
                            @click.stop="deleteAnswerPrompt(a)"
                            class="mg-l-5 btn btn-outline-light btn-xs btn-icon"
                            role="button"
                          >
                            <feather type="trash-2"></feather>
                          </button>
                        </div>
                      </div>
                    </template>
                    <div
                      v-else-if="selectedQuestionType.answer.mode == 1"
                      class="ivu-row"
                    >
                      <div
                        class="ivu-col ivu-col-span-24 text-center pd-50"
                        style="width:100%"
                      >
                        <img
                          src="assets/svg/nodata.svg"
                          style="width: 200px;"
                        />

                        <div class="text-muted">
                          Хариулт хоосон байна. шинээр хариулт нэмнэ үү
                        </div>
                      </div>
                    </div>
                  </template>
                </vue-custom-scrollbar>
              </div>
              <div v-else>
                <div
                  class="ivu-col ivu-col-span-24 text-center pd-50"
                  style="width:100%"
                >
                  <img src="assets/svg/nodata.svg" style="width: 200px;" />
                  <div class="text-muted"><br />Асуулт сонгоогүй байна.</div>
                </div>
              </div>
            </div>
            <div
              class="bd-l wd-15p pd-10"
              style="height: calc(100vh - 60px); overflow: auto"
            >
              <div>
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >ID</label
                >
                <p class="mg-b-20">{{ id }}</p>
              </div>
              <div>
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >Нэр</label
                >
                <p class="mg-b-20">{{ moreData.title }}</p>
              </div>
              <div v-show="flag == 500">
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >Оролдлогын тоо</label
                >
                <p class="mg-b-20">{{ moreData.attemptCount }}</p>
              </div>
              <div>
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >Эхлэх</label
                >
                <p class="mg-b-20">
                  {{ moreData.startDate | moment("YYYY.MM.DD HH:mm:ss") }}
                </p>
              </div>
              <div>
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >Дуусах</label
                >
                <p class="mg-b-20">
                  {{ moreData.endDate | moment("YYYY.MM.DD HH:mm:ss") }}
                </p>
              </div>
              <!-- {{moreData}} -->
              <!-- <task-info :fields="fields" :obj="obj" /> -->
              <div>
                <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
                  >Холбогдсон шалгалтууд</label
                >
                <ul class="list-group">
                  <li
                    class="list-group-item"
                    v-for="(lc, lci) in linkedCourses"
                    :key="lci"
                  >
                    {{ lci + 1 }}). {{ lc.courseName }}
                    <feather type="chevron-right"></feather>
                    {{ lc.lessonName }}
                    <feather type="chevron-right"></feather>
                    {{ lc.boxName }}
                  </li>
                </ul>
              </div>

              <div v-show='questionId > 0'  class="pd-t-10">
                <div class="d-flex wd-100p align-items-center pd-b-10">
                  <label
                  class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f">Файлууд</label>

                <Popover placement="right" width="400" trigger="click" class="ml-auto">
                  <a
                    slot="reference"
                    class="btn btn-outline-success btn-xs right"
                    >нэмэх</a
                  >

                  <simple-uploader
                    @on-success="fileUploadedQuestionAttach($event)"
                    :propBoxId="0"
                    :propObjectId="'0'"
                    :propObjectTypeId="6"
                    style="width:100%; max-width: 100%"
                  >
                    <div slot="trigger" class="wd-100p">
                      <a class="dropdown-item">Компьютероос хуулах</a>
                    </div>
                  </simple-uploader>
                </Popover>
                </div>
                

                <ul class="list-group">
                  <li
                    class="list-group-item d-flex wd-100p"
                    v-for="(qa, qai) in questionAttaches"
                    :key="`qai_${qai}`"
                  >
                    <a role="button" @click.stop="showAttach(qa.attachmentId)"
                      >{{ qa.fileName }} үзэх</a
                    >
                    <button
                      type="button"
                      @click.stop="removeQuestionAttach(qa.attachmentId)"
                      class="mg-l-auto text-danger "
                      role="button"
                    >
                      <feather type="x"></feather>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        v-if="selectedQuestionType != null"
        v-model="answerEdit.modal"
        title="Хариулт"
        width="50vw"
        size="lg"
      >
        <div
          v-if="selectedQuestionType.answer.mode == 1"
          class="ivu-row-flex d-flex"
        >
          <div class="wd-100p">
            <div v-show="selectedQuestionType.id != 41">
              <div class="">
                <div class="">
                  Хариулт
                  <Checkbox v-model="answerModel.editMode">HTML?</Checkbox>
                </div>
                <div
                  class="ivu-col text-right ivu-col-span-18"
                  v-if="flag == 600"
                >
                  <Checkbox v-model="answerModel.isResponse"
                    >Сонгосон тохиолдолд сонголтод байхгүй хариулт бичүүлэх
                    боломжтой</Checkbox
                  >
                </div>
              </div>
            </div>
            <div v-show="selectedQuestionType.id != 41">
              <textarea
                rows="6"
                v-if="!answerModel.editMode"
                v-model="answerModel.answer"
                class="el-textarea__inner"
              ></textarea>
              <div v-else>
                <div class="ivu-alert ivu-alert-warning ivu-alert-with-desc">
                  <span class="ivu-alert-message">Санамж</span>
                  <span class="ivu-alert-desc"
                    >Бусад програмаас хуулахгүй доорхи талбарыг ашиглаж
                    засварлана уу</span
                  >
                </div>
                <summernote
                  v-model="answerModel.answer"
                  :text="answerModel.answer"
                  :key="answerKey"
                ></summernote>
              </div>
            </div>

            <div
              v-if="
                ((selectedQuestionType.id == 3 ||
                  selectedQuestionType.id == 4 ||
                  selectedQuestionType.id == 41) &&
                  flag == 600) ||
                  flag == 800
              "
              class="ivu-col ivu-col-span-24 m-b-sm wd-100p"
            >
              <div>Файл</div>
              <simple-uploader
                @on-success="fileUploadedAnswer($event)"
                :propBoxId="0"
                :propObjectId="'0'"
                :propObjectTypeId="6"
                style="width:100%; max-width: 100%"
              >
                <div slot="trigger" class="wd-100p">
                  <a
                    v-if="
                      answerModel.attachmentId == 0 ||
                        answerModel.attachmentId == null
                    "
                    class="dropdown-item"
                    >Компьютероос хуулах
                  </a>
                  <div v-else class="btn-group wd-100p">
                    <div
                      class="btn btn-outline-success"
                      @click.stop="showAttach(answerModel.attachmentId)"
                    >
                      <feather type="eye"></feather>Файл харах
                    </div>
                    <div
                      class="btn btn-danger"
                      @click.prevent.stop="answerModel.attachmentId = null"
                    >
                      <feather type="x"></feather>Салгах
                    </div>
                  </div>
                </div>
              </simple-uploader>
            </div>
            <div
              v-if="selectedQuestionType.id == 41"
              class="ivu-col ivu-col-span-24 m-b-sm wd-100p"
            >
              <div>Файл (Тулгах зөв хариулт)</div>
              <simple-uploader
                @on-success="fileUploadedAnswerShablom($event)"
                :propBoxId="0"
                :propObjectId="'0'"
                :propObjectTypeId="6"
                style="width:100%; max-width: 100%"
              >
                <div slot="trigger" class="wd-100p">
                  <a
                    v-if="
                      answerModel.secondAttachmentId == 0 ||
                        answerModel.secondAttachmentId == null
                    "
                    class="dropdown-item"
                    >Компьютероос хуулах
                  </a>
                  <div v-else class="btn-group wd-100p">
                    <div
                      class="btn btn-outline-success"
                      @click.stop="showAttach(answerModel.secondAttachmentId)"
                    >
                      <feather type="eye"></feather>Файл харах
                    </div>
                    <div
                      class="btn btn-danger"
                      @click.prevent.stop="
                        answerModel.secondAttachmentId = null
                      "
                    >
                      <feather type="x"></feather>Салгах
                    </div>
                  </div>
                </div>
              </simple-uploader>
            </div>

            <div v-if="selectedQuestionType.id == 41">
              <div class="mg-t-10">
                Хариулт тулгах cell (Бүтэн файлаар бус зөвхөн тухайн cell зөв
                эсэхийг шалгах үед ашиглагдана)
              </div>
              <input
                rows="3"
                v-model="answerModel.shablom"
                class="el-textarea__inner"
                type="text"
              />
            </div>

            <div v-if="selectedQuestionType.answer.edit.group == 1">
              <div class="mg-t-10">
                {{
                  selectedQuestionType.id == 41
                    ? "Багананы тоо"
                    : "Хариултын бүлэг"
                }}
              </div>
              <input
                rows="3"
                v-model="answerModel.group"
                class="el-textarea__inner"
                type="number"
              />
            </div>
            <div v-if="selectedQuestionType.answer.edit.group == 0">
              <div class="mg-t-10">Хариултын бүлэг</div>
              <input
                disabled
                rows="3"
                v-model="answerModel.group"
                class="el-textarea__inner"
                type="number"
              />
            </div>
            <div v-if="selectedQuestionType.answer.edit.ord == 1">
              <div class="mg-t-10">
                {{
                  selectedQuestionType.id == 34
                    ? "харгалзах утга 1/2"
                    : selectedQuestionType.id == 41
                    ? "Мөрийн тоо"
                    : "Зөв дараалал"
                }}
              </div>
              <input
                v-model="answerModel.ord"
                class="el-textarea__inner"
                type="number"
              />
            </div>
            <div v-if="selectedQuestionType.answer.edit.ord == 0">
              <div class="mg-t-10">
                {{
                  selectedQuestionType.id == 34
                    ? "харгалзах утга 1/2"
                    : "Зөв дараалал"
                }}
              </div>
              <input
                disabled
                v-model="answerModel.ord"
                class="el-textarea__inner"
                type="number"
              />
            </div>
            <div class="mg-t-10">Тайлбар</div>
            <textarea
              rows="3"
              v-model="answerModel.info"
              class="el-textarea__inner"
            ></textarea>

            <div v-if="selectedQuestionType.answer.edit.point == 1">
              <div class="mg-t-10 d-flex">
                Оноо
                <section
                  @click="
                    answerModel.point = answerModel.point == 100 ? 0 : 100
                  "
                  class="mg-l-10"
                >
                  <input
                    type="checkbox"
                    :checked="answerModel.point == 100"
                    id="chkmaxtrue"
                    class="mg-r-5"
                  />
                  <label for="chkmaxtrue">Зөв хариулт эсэх?</label>
                </section>
              </div>
              <input
                v-model="answerModel.point"
                type="number"
                class="el-input__inner"
              />
              <div data-v-fbae3e96 class="text-muted tx-11 eddt-title-info">
                Зөв хариулт бол оноог 100 гэж оруулна уу.
              </div>
            </div>
          </div>
        </div>
        <template #modal-footer>
          <div class="w-100">
            <button
              @click="postAnswer()"
              type="button"
              class="btn btn-success btn-sm"
            >
              <feather
                type="check"
                class="feather feather-chevron-down ht-15 pd-r-5"
              ></feather>
              Хариулт {{ answerModel.id == 0 ? "нэмэх" : "засах" }}
            </button>
            <button
              v-if="answerModel.id > 0"
              @click="editAnswer(0)"
              type="button"
              class="btn btn-danger btn-sm"
            >
              <feather
                type="x"
                class="feather feather-chevron-down ht-15 pd-r-5"
              ></feather
              >Болих
            </button>
          </div>
        </template>
      </b-modal>

      <b-modal
        v-model="sectionObj.modal"
        title="Бүлэг"
        hide-footer
        width="50vw"
        size="lg"
      >
        <Form label-position="right" label-width="200">
          <FormItem label="Бүлгийн нэршил">
            <Input v-model="sectionObj.editName" />
          </FormItem>
          <FormItem label="Эрэмбэ">
            <InputNumber v-model="sectionObj.editOrd"></InputNumber>
          </FormItem>
          <FormItem label="Тайлбар">
            <summernote
              v-model="sectionObj.editInfo"
              :text="sectionObj.editInfo"
              :key="sectionObj.editKey"
              class="m-t-sm m-b-sm"
            ></summernote>
          </FormItem>
        </Form>
        <div class="d-flex">
          <button @click="postSection()" class="btn btn-primary mg-l-auto">
            Хадгалах
          </button>
        </div>
      </b-modal>

      <b-modal
        v-model="qtObj.modal"
        hide-footer
        title="Загвар асуулт сонгоно уу"
        centered
        scrollable
      >
        <nav class="nav flex-column nav-chat">
          <a
            @click="chooseTemplQ(l)"
            v-for="(l, i) in qtObj.list"
            :key="i"
            href="#general"
            class="nav-link active"
            >{{ i + 1 }}). {{ l.question }}</a
          >
        </nav>
      </b-modal>

      <b-modal
        v-model="testBankObj.modal"
        title="Сонгоно уу"
        centered
        hide-footer
      >
        <Form label-position="right" label-width="200">
          <FormItem label="Сургалт">
            <Select
              v-model="testBankObj.courseId"
              filterable
              clearable
              @change="loadLesson"
              class="wd-100p"
            >
              <Option
                v-for="(t, i) in testBankObj.tasks"
                :value="t.id"
                :key="i"
                :label="`${i + 1}.) ${t.task}`"
                >{{ i + 1 }}.) {{ t.task }} ({{
                  t.dueStartDate | moment("YYYY.MM.DD")
                }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
              >
            </Select>
          </FormItem>
          <FormItem label="Хичээл">
            <Select
              v-model="testBankObj.lessonId"
              filterable
              clearable
              @change="loadBox"
              class="wd-100p"
            >
              <Option
                v-for="(t, i) in testBankObj.lessons"
                :value="t.id"
                :key="i"
                :label="`${i + 1}.) ${t.task}`"
                >{{ i + 1 }}.) {{ t.task }} ({{
                  t.dueStartDate | moment("YYYY.MM.DD")
                }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
              >
            </Select>
          </FormItem>
          <FormItem label="Шалгалт">
            <Select
              v-model="testBankObj.boxId"
              filterable
              clearable
              class="wd-100p"
            >
              <Option
                v-for="(t, i) in testBankObj.boxes"
                :value="t.id"
                :key="i"
                :label="`${i + 1}.) ${t.nm}`"
                >{{ i + 1 }}.) {{ t.nm }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="Шалгалтын төрөл">
            <loc-type-cascader
              v-model="testBankObj.locTypeId"
              :getParentType="true"
              disableAdd
              locTypekey="formType"
              class="wd-100p"
            />
          </FormItem>
        </Form>
        <div class="d-flex">
          <button @click="postTestBank()" class="btn btn-primary mg-l-auto">
            Хичээлийн шалгалтыг үүсгэж турших
          </button>
        </div>
      </b-modal>
      <b-modal v-model="fileDialog.modal" hide-footer size="lg" scrollable>
        <template v-if="fileDialog.blank">
          <img class="wd-100p" :src="fileDialog.src" />
        </template>
        <file-dialog
          v-else
          :show="fileDialog.show"
          :id.sync="fileDialog.id"
          @on-hide="
            fileDialog.show = false;
            fileDialog.modal = false;
          "
          :force="true"
        />
      </b-modal>
    </div>
  </b-sidebar>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import { mapActions } from "vuex";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  DatePicker,
  //Divider,
  InputNumber,
  Select,
  //OptionGroup,
  Option,
  Notification,
  Checkbox,
  Message,
  //RadioGroup,
  //Radio
  MessageBox,
  Popover,
} from "element-ui";

const moment = require("moment");
var _ = require("lodash");

export default {
  components: {
    Popover,
    vueCustomScrollbar,
    Form,
    FormItem,
    Input,
    DatePicker,
    //Divider,
    InputNumber,
    Select,
    //OptionGroup,
    Option,
    Checkbox,
    MessageBox,
    //RadioGroup,
    //Radio,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    confirmModal: () => ({
      component: import("@/components/modules/confirm/confirm.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    permissionUsers: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    flag: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      fileDialog: {
        modal: false,
        show: false,
        id: 0,
        blank: false,
        src: "",
      },
      qtObj: {
        modal: false,
        list: [],
        hideQt: false,
        cloneId: null,
      },
      activeQuestion: {
        id: 0,
      },
      loading: true,
      formObj: {
        loaded: false,
        columns: [],
        task: {},
      },
      showSidebar: false,
      // fileDialog: {
      //   show: false,
      //   id: 0,
      // },
      fetched: false,
      moreData: {
        title: "",
        questionData: {
          count: 0,
          questions: [],
        },
      },
      questionId: 0,
      answerModel: {
        id: 0,
        answer: "",
        point: 0,
        attachmentId: null,
        attachmentName: "",
        secondAttachmentId: null,
        secondAttachmentName: "",
        isResponse: false,
        info: "",
        group: 0,
        ord: 0,
        shablom: "",
      },
      questionModel: {
        show: false,
        id: 0,
        formId: this.id,
        question: "",
        info: "",
        answerTypeId: 4,
        libraryId: null,
        point: 0,
        count: 0,
        editMode: false,
        isRequired: false,
        requiredText: "",
        tip: "",
        matchValue: "",
        sectionId: null,
        attachmentId: null,
        attachmentName: "",
        linearMin: null,
        linearMax: null,
        questionViewType: null,
        answerViewType: null,
      },
      questionKey: 0,
      answerKey: 0,
      libraries: [],
      librariesRaw: [],
      librariesMove: [],
      selectedLocTypeId: 0,
      sectionObj: {
        list: [],
        editName: "",
        editInfo: "",
        editOrd: 0,
        editKey: 0,
        editId: 0,
        modal: false,
      },
      confirmModel: {
        id: 0,
        custom: 0,
        cmd: "",
        promptMsg: "Устгахдаа итгэлтэй байна уу ?",
        okMsg: "Устгах",
        okType: "error",
        okIcon: "md-trash",
      },
      moveObj: {
        id: 0,
        show: false,
        libraryId: 0,
      },
      mentionObj: {
        show: false,
        id: 0,
        shareFlag: 1,
      },
      permissionObj: {
        show: false,
      },
      selectedQuestionData: {},
      selectedQuestionType: null,
      answerEdit: {
        modal: false,
      },
      questionTypes: [
        {
          id: 6,
          label: "Санамсаргүй асуулт /Тестийн сан/",
          flag: [500, 900],
          disabled: false,
          answer: {
            mode: -1,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 1,
          label: "Хариултыг нэг мөр текстээр оруулах",
          flag: [700, 800],
          disabled: false,
          answer: {
            mode: 0,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 4,
          label: "Нэг хариулт сонгох боломжтой",
          flag: [700, 800],
          disabled: false,
          questionViewTypes: [
            {
              id: 0,
              label: "------",
              disabled: true,
            },
            { id: 0, label: "Уламжлалт", disabled: false },
            {
              id: 1,
              label: "Зураг болон текст хамт харагдах",
              disabled: false,
            },
            { id: 2, label: "Зөвхөн зураг харуулах", disabled: false },
          ],
          answerViewTypes: [
            {
              id: 0,
              label: "------",
              disabled: true,
            },
            { id: 0, label: "Босоо буюу доош цуварсан" },
            { id: 1, label: "Хөндлөн буюу нэг эгнээнд цуварсан" },
          ],
          answer: {
            mode: 1,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 3,
          label: "Олон хариулт сонгох боломжтой",
          flag: [700, 800],
          disabled: false,
          questionViewTypes: [
            {
              id: 0,
              label: "------",
              disabled: true,
            },
            { id: 0, label: "Уламжлалт", disabled: false },
            {
              id: 1,
              label: "Зураг болон текст хамт харагдах",
              disabled: false,
            },
            { id: 2, label: "Зөвхөн зураг харуулах", disabled: false },
          ],
          answerViewTypes: [
            {
              id: 0,
              label: "------",
              disabled: true,
            },
            { id: 0, label: "Босоо буюу доош цуварсан" },
            { id: 1, label: "Хөндлөн буюу нэг эгнээнд цуварсан" },
          ],
          answer: {
            mode: 1,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 7,
          label: "Хариултыг зөвхөн тоон утгаар оруулах",
          flag: [700, 800],
          disabled: false,
          answer: {
            mode: 0,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 11,
          label: "Хариултыг олон мөр текстээр оруулах",
          flag: [700, 800],
          disabled: false,
          answer: {
            mode: 0,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: null,
          label: "------",
          flag: [800],
          disabled: true,
        },
        {
          id: 21,
          label: "Хариултыг мөнгөн дүнгээр оруулах",
          flag: [800],
          disabled: false,
          answer: {
            mode: 0,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 22,
          label: "Хариултыг огноогоор оруулах",
          flag: [800],
          disabled: false,
          answer: {
            mode: 0,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 23,
          label: "Yes or No (хариулт сонгох үед нэмэлт тайлбар бичих цонхтой)",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 24,
          label: "Yes or No (хариулт сонгох үед нэмэлт тайлбар бичих цонхгүй)",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            edit: {
              point: 1,
              group: -1,
              ord: -1,
            },
            list: {
              point: 1,
              group: -1,
              ord: -1,
            },
          },
        },
        {
          id: 31,
          label: "Өгүүлбэрийг гүйцээж нөхөх",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            edit: {
              point: 1,
              group: 1,
              ord: -1,
            },
            list: {
              point: 1,
              group: 1,
              ord: -1,
            },
          },
        },
        {
          id: 32,
          label: "Зөв дараалалд оруулах",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            edit: {
              point: -1,
              group: -1,
              ord: 1,
            },
            list: {
              point: -1,
              group: -1,
              ord: 1,
            },
          },
        },
        {
          id: 33,
          label:
            "Зөв дараалалд оруулах /Пирамид дүрсээр эрэмбэлэх 2-4 хариулттай/",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            edit: {
              point: -1,
              group: -1,
              ord: 1,
            },
            list: {
              point: -1,
              group: -1,
              ord: 1,
            },
          },
        },
        {
          id: 34,
          label: "Зөв дараалалд оруулах Дугуй дүрс 4 хариулттай",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            newBtnDisabled: true,
            edit: {
              point: -1,
              group: 0,
              ord: 0,
            },
            list: {
              point: -1,
              group: 1,
              ord: 1,
            },
          },
        },
        {
          id: null,
          label: "------",
          flag: [800],
          disabled: true,
        },
        {
          id: 41,
          label: "Тодорхой загвараар оруулсан эксэл файл дээр эдит хийх",
          flag: [800],
          disabled: false,
          answer: {
            mode: 1,
            newBtnDisabled: true,
            edit: {
              point: 1,
              group: 1,
              ord: 1,
            },
            list: {
              point: -1,
              group: 1,
              ord: 1,
            },
          },
        },
      ],
      testBankObj: {
        modal: false,
        courseId: null,
        lessonId: null,
        boxId: null,
        locTypeId: null,
        tasks: [],
        lessons: [],
        boxes: [],
      },
      linkedCourses: [],
      questionAttaches: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleUserInfoModal"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fileUploadedSimple(e) {
      this.questionModel.attachmentId = e.uploadedAttachmentId;
    },
    fileUploadedAnswer(e) {
      //console.log(e);
      this.answerModel.attachmentId = e.uploadedAttachmentId;
      this.answerModel.attachmentName = e.uploadedName;
    },
    fileUploadedAnswerShablom(e) {
      //console.log(e);
      this.answerModel.secondAttachmentId = e.uploadedAttachmentId;
      this.answerModel.secondAttachmentName = e.uploadedName;
    },
    showAttach(id, blank) {
      if (blank != undefined && blank) {
        this.fileDialog.blank = true;
        this.fileDialog.src = id;
      } else {
        this.fileDialog.blank = false;
        this.fileDialog.id = id;
      }
      this.fileDialog.show = true;
      this.fileDialog.modal = true;
    },
    init(qid) {
      this.showSidebar = true;
      this.handleLoading({ isLoading: false });
      this.fetched = false;
      this.$nextTick(() => {
        request({
          api: { method: "GET", url: "Form/FormDetail" },
          params: {
            id: this.id,
          },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            //console.log("res.data.form", res.data.form);
            this.moreData = res.data.form;
            this.fetched = true;
            this.$emit("on-updated", {
              id: this.id,
              count: this.moreData.questionData.questions.length,
            });
            if (qid != undefined) {
              if (qid > 0) {
                //console.log(qid);
                this.showAnswers(qid);
              } else {
                this.questionId = 0;
                this.selectedQuestionData = {};
                this.selectedQuestionType = null;
              }
            } else {
              this.questionId = 0;
              this.selectedQuestionData = {};
              this.selectedQuestionType = null;
            }
            if (this.flag == 900 || this.flag == 500) {
              this.questionModel.answerTypeId = 6;
              let _mdole = {
                flag: 800,
                title: "",
                locTypeId: 0,
                formId: this.id,
              };
              request({
                api: { method: "post", url: "Form/FormSelectList" },
                params: _mdole,
                store: this.$store,
              }).then((res) => {
                if (res != false) {
                  this.librariesRaw = res.data.forms;
                  this.libraries = res.data.forms;
                }
              });
            }
            //else if(this.flag==600){
            this.initSections();
            //}
          } else {
            this.visibleChanged(false);
          }
        });
      });

      this.initRelated();
    },
    initQuestionAttaches() {
      request({
        api: { method: "GET", url: "Form/GetQuestionInAttachList" },
        params: { questionId: this.questionId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          this.questionAttaches = res.data.attaches;
        }
      });
    },
    removeQuestionAttach(attachmentId) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Form/RemoveQuestionInAttach" },
        data: { questionId: this.questionId, attachmentId: attachmentId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.initQuestionAttaches();
          //console.log('res', res);
          //this.linkedCourses = res.data.forms;
        }
      });
    },
    fileUploadedQuestionAttach(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Form/PostQuestionInAttach" },
        data: {
          questionId: this.questionId,
          attachmentId: e.uploadedAttachmentId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.initQuestionAttaches();
          //console.log('res', res);
          //this.linkedCourses = res.data.forms;
        }
      });
      //this.answerModel.secondAttachmentId = e.uploadedAttachmentId;
      //this.answerModel.secondAttachmentName = e.uploadedName;
    },
    initRelated() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Form/FormInBoxList" },
        params: { id: this.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          this.linkedCourses = res.data.forms;
        }
      });
    },
    hasOneOf(arr1, arr2) {
      return hasOneOf(arr1, arr2);
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    showUserPermission() {
      this.permissionObj.id = this.id;
      this.permissionObj.show = true;
      //   this.$nextTick(function() {
      //     this.permissionObj.show = true;
      //   });
    },
    showMention() {
      this.mentionObj.id = this.id;
      this.mentionObj.show = true;
    },
    menuClicked(name) {
      switch (name) {
        case "edit":
          this.editForm();
          break;
        case "delete":
          this.confirmModel.custom = this.id;
          this.confirmModel.promptMsg =
            "одооноос хойшхи хугацаанд болох шалгалтанд уг тестийн сангаас асуултууд сонгосон бол зөөвөрлөгдсөн асуултууд шалгалтанд сонгогдохгүй ба хэдэн асуулт уг тестийн сангаас шалгалтанд оруулахаар сонгосныг анхаарна уу.";
          this.confirmModel.okIcon = "ios-archive-outline";
          this.confirmModel.okType = "warning";
          this.confirmModel.okMsg = "Архивлах";
          this.confirmModel.cmd = "form";
          this.confirmModel.id = this.id;
          break;
        case "permission":
          this.showUserPermission();
          break;
        case "share":
          this.showMention();
          break;
        case "shareMember":
          this.mentionObj.id = this.id;
          this.mentionObj.shareFlag = 6;
          this.mentionObj.show = true;
          //   this.$nextTick(() => {
          //     this.$refs.mentionBtn.init();
          //   });
          break;
        case "showStat":
          window.open("/#/learn/surveystat/" + this.id, "_blank");
          break;
        case "result":
          Message({
            message: "Хийгдэж байна...",
            type: "info",
          });
          //   if (!this.resultConfig.render) this.resultForm();
          //   else this.resultConfig.show = false;
          break;
        case "export":
          this.exportForm();
          break;
        case "exportFormData":
          this.exportFormData();
          break;
        case "printFormData":
          this.printFormData();
          break;
        case "embedForm":
          this.embedForm();
          break;
        case "duplicateFormData":
          this.duplicateForm();
          break;
        case "testBank":
          this.testBankDo();
          break;
        default:
          break;
      }
    },
    menuClickedQuestion(name) {
      //console.log('menuClickedQuestion=> ', name);
      switch (name) {
        case "edit":
          this.editQuestion(
            this.moreData.questionData.questions.filter(
              (q) => q.id == this.questionId
            )[0]
          );
          break;
        case "delete":
          //console.log('step 1');
          this.deleteQuestionPrompt(
            this.moreData.questionData.questions.filter(
              (q) => q.id == this.questionId
            )[0]
          );
          break;
        case "move":
          this.confirmModel.custom = this.questionId;
          this.confirmModel.promptMsg =
            "одооноос хойшхи хугацаанд болох шалгалтанд уг тестийн сангаас асуултууд сонгосон бол зөөвөрлөгдсөн асуултууд шалгалтанд сонгогдохгүй ба хэдэн асуулт уг тестийн сангаас шалгалтанд оруулахаар сонгосныг анхаарна уу.";
          this.confirmModel.okIcon = "ios-move";
          this.confirmModel.okType = "warning";
          this.confirmModel.okMsg = "Зөөх";
          this.confirmModel.cmd = "move";
          this.confirmModel.id = this.questionId;
          break;
        case "template":
          //console.log('step 2');
          this.confirmModel.custom = this.questionId;
          this.confirmModel.promptMsg =
            "Асуултын загвар болгох гэж байна. Итгэлтэй банйа уу?";
          this.confirmModel.okIcon = "ios-archive-outline";
          this.confirmModel.okType = "warning";
          this.confirmModel.okMsg = "Загвар болгох";
          this.confirmModel.cmd = "maketemplate";
          this.confirmModel.id = this.questionId;
          break;
        default:
          break;
      }
    },
    templateQuestionPrompt() {},
    deleteQuestionPrompt(q) {
      this.confirmModel.promptMsg = "Устгахдаа итгэлтэй байна уу ?";
      this.confirmModel.okMsg = "Устгах";
      this.confirmModel.custom = q.id;
      this.confirmModel.cmd = "question";
      this.confirmModel.id = q.id;
    },
    deleteAnswerPrompt(a) {
      this.confirmModel.okMsg = "Устгах";
      this.confirmModel.custom = a.questionId;
      this.confirmModel.cmd = "answer";
      this.confirmModel.id = a.id;
    },
    promptOk(e) {
      switch (e.cmd) {
        case "question": {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/DeleteQuestion" },
            data: { id: e.id },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.confirmModel.id = 0;
              Message({
                message: "Амжилттай",
                type: "success",
              });
              this.showAnswers(e.custom);
              this.init();
            }
          });
          break;
        }
        case "answer": {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/DeleteAnswer" },
            data: { id: e.id },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.confirmModel.id = 0;
              Message({
                message: "Амжилттай",
                type: "success",
              });
              this.questionId = 0;
              this.init(e.custom);
            }
          });
          break;
        }
        case "form": {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/DeleteForm" },
            data: { id: e.id },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.confirmModel.id = 0;
              Message({
                message: "Амжилттай",
                type: "success",
              });
              this.moreData = {
                title: "",
                questionData: {
                  count: 0,
                  questions: [],
                },
              };
              this.questionId = 0;
              this.resultConfig = {
                chartIndex: 0,
                render: false,
                show: false,
                chartStrData: [],
                chartStrFields: [],
                chartStrFieldsWithData: [],
                textStrData: [],
                textStrFields: [],
                textStrFieldsWithData: [],
              };
              this.$emit("on-reload");
            }
          });

          break;
        }
        case "move": {
          let _mdole = { flag: this.flag, title: "", locTypeId: 0 };
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/FormSelectList" },
            params: _mdole,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.librariesMove = res.data.forms.filter(
                (x) => x.id != this.id
              );

              this.moveObj.id = e.id;
              this.moveObj.show = true;
              this.confirmModel.id = 0;
            }
          });

          break;
        }
        case "maketemplate": {
          //console.log(e);
          let _mdole = { flag: this.flag, title: "", locTypeId: 0 };
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/SetAsTemplate" },
            data: { id: e.id },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.confirmModel.id = 0;
              Notification.success({ message: "Амжилттай", duration: 5000 });
            }
          });
          break;
        }
        default: {
          break;
        }
      }
    },
    editForm() {
      this.$emit("on-edit", this.moreData);
    },
    exportFormData() {
      let questionCount = prompt("Асуултын тоог оруулна уу.", "");
      if (questionCount != null && questionCount != undefined) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "post", url: "Form/exportFormData" },
          data: {
            count: questionCount,
            id: this.id,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.$emit("on-attach", { id: res.data.file.id });
          }
        });
      }
    },
    exportForm() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Form/exportData" },
        data: {
          id: this.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$emit("on-attach", { id: res.data.file.id });
        }
      });
    },
    testBankDo() {
      let self = this;
      MessageBox.confirm("Та санг туршихдаа итгэлтэй байна уу ", "Мэдэгдэл", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        callback: (action) => {
          if (action == "cancel") {
            //console.log('step 1');
          } else if (action == "confirm") {
            this.toggleBodyClass("addClass", "dynamic-locker");
            let _pid = 0;
            let proj = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 115
            );
            if (proj.length) {
              _pid = proj[0].id;
              request({
                api: { method: "POST", url: "TaskCore/GetCoreList" },
                data: {
                  projectId: _pid,
                  skip: 0,
                  size: 2000,
                  id: 0,
                  model: {},
                },
                store: this.$store,
              }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res.data.tasks.length > 0)
                  this.testBankObj.tasks = _.orderBy(
                    res.data.tasks,
                    ["id"],
                    ["desc"]
                  );
                else
                  this.testBankObj.tasks = [
                    { id: 0, task: "Байгууллагын админд хандана уу" },
                  ];

                this.testBankObj.modal = true;
              });
            }

            // self.toggleBodyClass("addClass", "dynamic-locker");
            // request({
            //     api: { method: "POST", url: "Type/deleteType" },
            //     data:{ id: e.data.id },
            //     store: self.$store
            // }).then(res => {
            //   self.toggleBodyClass("removeClass", "dynamic-locker");
            //   if (res != false) {
            //     let _key= self.keyCur;
            //     self.keyCur={id: null}
            //     self.loadKey(_key);
            //   }
            // })
          }
        },
      });
    },
    duplicateForm() {
      if (confirm("Хуулбар үүсгэхдээ итгэлтэй байна уу?")) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "post", url: "Form/FormDuplicate" },
          data: {
            id: this.id,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            if (res.data.form.id > 0) {
              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "GET", url: "Form/FormDetail" },
                params: {
                  id: res.data.form.id,
                },
                store: this.$store,
              }).then((resf) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (resf != false) {
                  Notification.success({
                    message: "Амжилттай хуулбар үүсгэлээ.",
                    duration: 5000,
                  });

                  this.$emit("on-edit", resf.data.form);
                  //this.$emit("on-duplicate", { id: res.data.form.id });
                }
              });
            }
          }
        });
      }
    },
    initSections() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Form/SectionList" },
        params: { formId: this.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.sectionObj.list = res.data.list;
        }
      });
    },
    locTypeChanged(e) {
      if (e.id != null) {
        this.libraries = this.librariesRaw.filter((x) => x.locType.id == e.id);
      } else {
        this.libraries = this.librariesRaw;
      }
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-form-close");
      }
    },

    showAnswers(id, mode) {
      if (this.questionId == id && mode == 1) {
        this.questionId = 0;
        this.selectedQuestionData = {};
        this.selectedQuestionType = null;
        this.editAnswer(0);
      } else {
        this.questionId = id;
        this.selectedQuestionData = this.moreData.questionData.questions.filter(
          (q) => q.id == this.questionId
        )[0];
        this.selectedQuestionType = this.questionTypes.filter(
          (x) => x.id == this.selectedQuestionData.answerTypeId
        )[0];
        this.editAnswer(0);

        this.initQuestionAttaches();
      }
    },
    editSection(s) {
      if (s.id > 0) {
        this.sectionObj.editName = s.name;
        this.sectionObj.editId = s.id;
        this.sectionObj.editOrd = s.ord;
        this.sectionObj.editInfo = s.info;
        this.sectionObj.editKey++;
      } else {
        this.sectionObj.editName = "";
        this.sectionObj.editId = 0;
      }
      this.sectionObj.modal = true;
    },
    postSection() {
      //formSectionPost({ id: this.sectionObj.editId, formId: this.id, name: this.sectionObj.editName, info: this.sectionObj.editInfo, ord: this.sectionObj.editOrd })
      request({
        api: { method: "POST", url: "Form/PostSection" },
        data: {
          id: this.sectionObj.editId,
          formId: this.id,
          name: this.sectionObj.editName,
          info: this.sectionObj.editInfo,
          ord: this.sectionObj.editOrd,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.sectionObj.editName = "";
          this.sectionObj.editId = 0;
          this.sectionObj.editOrd = 0;
          this.sectionObj.editInfo = "";

          this.sectionObj.modal = false;
          this.initSections();
        }
      });
    },
    editAnswer(a, add) {
      //console.log(this.selectedQuestionData.answerTypeId);
      if (a == 0) {
        this.answerModel.id = 0;
        this.answerModel.answer = "";
        this.answerModel.point = 0;
        this.answerModel.attachmentId = null;
        this.answerModel.attachmentName = "";
        this.answerModel.secondAttachmentId = null;
        this.answerModel.secondAttachmentName = "";
        this.answerModel.shablom = "";
        this.answerModel.isResponse = false;
        this.answerModel.info = "";
        this.answerModel.group = 0;
        this.answerModel.ord = 0;

        this.answerEdit.modal = add == 1;
        if (this.selectedQuestionData.answerTypeId == 41) {
          this.answerModel.answer = "Зөвхөн файл оруулах боломжтой";
        }
      } else {
        this.answerModel.id = a.id;
        this.answerModel.answer = a.answer;
        this.answerModel.point = a.mass;
        this.answerModel.attachmentId = a.attachmentId;
        this.answerModel.attachmentName = a.attachmentName;
        this.answerModel.secondAttachmentId = a.secondAttachmentId;
        this.answerModel.secondAttachmentName = a.secondAttachmentName;
        this.answerModel.shablom = a.shablom;
        this.answerModel.isResponse = a.isResponse;
        this.answerModel.info = a.info;
        this.answerModel.ord = a.ord;
        this.answerModel.group = a.group;
        this.answerEdit.modal = true;
      }

      this.answerKey++;
    },
    editQuestion(q) {
      if (q == 0) {
        this.questionModel.question = "";
        this.questionModel.id = 0;

        this.questionModel.isRequired = false;
        this.questionModel.requiredText = "Заавал бөглөх";
        this.questionModel.tip = "";
        this.questionModel.matchValue = "";

        this.questionModel.attachmentId = null;
        this.questionModel.attachmentName = "";

        this.questionModel.linearMin = null;
        this.questionModel.linearMax = null;
        this.questionModel.questionViewType = null;
        this.questionModel.answerViewType = null;
      } else {
        this.questionModel.answerTypeId = q.answerTypeId;
        this.questionModel.question = q.question;
        this.questionModel.info = q.info;
        this.questionModel.id = q.id;
        this.questionModel.isRequired = q.isRequired;
        this.questionModel.requiredText =
          q.requiredText == null || q.requiredText == ""
            ? "Заавал бөглөх"
            : q.requiredText;
        this.questionModel.tip = q.tip;

        if (q.answerTypeId == 22) {
          this.questionModel.matchValue = q.matchValue; // moment(q.matchValue).format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.questionModel.matchValue = q.matchValue;
        }

        this.questionModel.sectionId = q.sectionId;
        this.questionModel.attachmentId = q.attachmentId;
        this.questionModel.attachmentName = q.attachmentName;
        this.questionModel.linearMin = q.linearMin;
        this.questionModel.linearMax = q.linearMax;
        if (this.flag == 900) {
          this.questionModel.point = q.point;
          this.questionModel.libraryId = q.libraryId;
        }

        this.questionModel.questionViewType = q.questionViewType;
        this.questionModel.answerViewType = q.answerViewType;
      }

      this.questionModel.show = true;

      this.questionKey++;
    },
    chooseTemplQ(l) {
      this.qtObj.hideQt = true;
      this.qtObj.cloneId = l.id;

      this.questionModel.question = l.question;
      this.questionModel.info = l.info;
      this.questionModel.matchValue = l.matchValue;
      //this.questionModel.formId= l.formId;

      this.qtObj.modal = false;
    },
    chooseFromQuestionTemplate() {
      if (this.questionModel.sectionId > 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "Form/GetQuestionTemplateList" },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.qtObj.list = res.data.questions;
            this.qtObj.modal = true;
            //console.log('res', res);
          }
        });
      } else {
        Notification.warning({ message: "Бүлэг сонгоно уу", duration: 5000 });
      }
    },
    clearQuestionModel() {
      this.questionModel = {
        show: false,
        id: 0,
        formId: 0,
        question: "",
        info: "",
        answerTypeId: 4,
        libraryId: 0,
        point: 0,
        count: 0,
        isRequired: false,
        matchValue: "",
      };
    },
    postQuestionClone() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.questionModel.formId = this.id;
      request({
        api: { method: "post", url: "Form/CloneQuestion" },
        data: {
          cloneId: this.qtObj.cloneId,
          sectionId: this.questionModel.sectionId,
          formId: this.questionModel.formId,
          question: this.questionModel.question,
          info: this.questionModel.info,
          matchValue: this.questionModel.matchValue,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.questionModel.show = false;
          this.clearQuestionModel();
          //this.init();
          this.init(res.data.questionId);
        }
      });
    },
    postQuestion() {
      let errs = [];
      if (this.questionModel.question == "" && this.questionModel.count < 1) {
        errs.push("Асуулт оруулна уу !");
      }
      if (errs.length == 0) {
        this.questionModel.formId = this.id;
        if (this.questionModel.count < 1) {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Form/PostQuestion" },
            data: this.questionModel,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              if (
                this.questionModel.id == 0 &&
                (this.questionModel.answerTypeId == 23 ||
                  this.questionModel.answerTypeId == 24)
              ) {
                //console.log('step 3');
                this.postQuestionAfter(res.data.questionId);
              } else if (
                this.questionModel.id == 0 &&
                this.questionModel.answerTypeId == 34
              ) {
                this.post34CircleQuestionAfter(res.data.questionId, 1);
              } else {
                //console.log('step 4');
                this.questionModel.show = false;
                this.clearQuestionModel();
                this.init(res.data.questionId);
              }
            }
          });
        } else {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "v2/Form/PostQuestionPack" },
            data: this.questionModel,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.questionModel.show = false;
              this.clearQuestionModel();
              this.init();
            }
          });
        }
      } else {
        this.$Notice.error({
          title: "Алдаа гарлаа",
          desc: errs[0],
        });
      }
    },
    postQuestionAfter(questionId) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Form/PostAnswer" },
        data: { questionId: questionId, answer: "Тийм" },
        store: this.$store,
      }).then(() => {
        request({
          api: { method: "post", url: "Form/PostAnswer" },
          data: { questionId: questionId, answer: "Үгүй" },
          store: this.$store,
        }).then(() => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          this.questionModel.show = false;
          this.clearQuestionModel();
          this.init(questionId);
        });
      });
    },
    post34CircleQuestionAfter(questionId, group) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Form/PostAnswer" },
        data: {
          questionId: questionId,
          answer: `Асуулт ${group}`,
          ord: 0,
          group: group,
        },
        store: this.$store,
      }).then(() => {
        request({
          api: { method: "post", url: "Form/PostAnswer" },
          data: {
            questionId: questionId,
            answer: `Хариулт ${group}`,
            ord: group,
            group: group,
          },
          store: this.$store,
        }).then(() => {
          if (group < 4) this.post34CircleQuestionAfter(questionId, group + 1);
          else {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            this.questionModel.show = false;
            this.clearQuestionModel();
            this.init(questionId);
          }
        });
      });
    },
    postAnswer() {
      let errs = [];
      let _q = this.moreData.questionData.questions.filter(
        (q) => q.id == this.questionId
      );
      if (_q.length > 0) {
        if (
          this.flag == 600 &&
          (_q[0].answerTypeId == 1 ||
            _q[0].answerTypeId == 7 ||
            _q[0].answerTypeId == 11)
        ) {
          errs.push("Бөглөх асуултад хариулт нэмэх боломжгүй !");
        }
      }

      if (this.answerModel.answer == "") {
        errs.push("Хариулт оруулна уу !");
      }

      // if (this.answerModel.answer == "") {
      //   errs.push("Хариулт оруулна уу !");
      // }

      if (errs.length == 0) {
        this.answerModel.questionId = this.questionId;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "post", url: "Form/PostAnswer" },
          data: this.answerModel,
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.editAnswer(0);
            this.init(this.answerModel.questionId);
          }
        });
      } else {
        Notification.error({
          message: errs[0],
          duration: 5000,
          type: "error",
          position: "top-right",
          offset: 50,
        });
      }
    },
    getColor(q) {
      if (
        q.answerTypeId == 3 ||
        q.answerTypeId == 4 ||
        q.answerTypeId == 23 ||
        q.answerTypeId == 24
      )
        return q.formAnswerData.filter((x) => x.mass > 0).length > 0
          ? "inherit"
          : "red !important";
      else if (
        q.answerTypeId == 7 ||
        q.answerTypeId == 21 ||
        q.answerTypeId == 22
      ) {
        //console.log(q.matchValue);
        return q.matchValue == "" ||
          q.matchValue == null ||
          q.matchValue == undefined
          ? "red !important"
          : "inherit";
      }
    },
    chkMaxTrueChanged(cb) {
      //console.log(cb);
      if (cb != undefined && (cb.target.value || cb.target.value == "on")) {
        this.answerModel.point = 100;
      } else {
        this.answerModel.point = 0;
      }
    },

    loadLesson(e) {
      if (e > 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "task/taskInheritedDetail" },
          params: {
            id: e,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('taskInheritedDetail', res);
            let tb = res.data.task.b;
            if (tb.length > 0) {
              if (tb.filter((b) => b.ot == 114).length > 0) {
                this.toggleBodyClass("addClass", "dynamic-locker");
                let bid = tb.filter((b) => b.ot == 114)[0].id;
                request({
                  api: { method: "post", url: "taskCore/coreBoxInTaskList" },
                  data: {
                    id: bid,
                    skip: 0,
                    size: 500,
                  },
                  store: this.$store,
                }).then((resb) => {
                  //console.log('coreBoxInTaskList', resb);
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (resb != false) {
                    this.testBankObj.lessons = resb.data.tasks;
                  }
                });
              }
            }
          }
        });
      } else {
        this.testBankObj.lessons = [];
      }
    },
    loadBox(e) {
      if (e > 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "task/taskInheritedDetail" },
          params: {
            id: e,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('taskInheritedDetail', res);
            let tb = res.data.task.b;
            if (tb.length > 0) {
              if (tb.filter((b) => b.ot == 416).length > 0) {
                this.testBankObj.boxes = tb.filter((b) => b.ot == 416);

                if (tb.filter((b) => b.ot == 416).length == 1) {
                  this.testBankObj.boxId = tb.filter((b) => b.ot == 416)[0].id;
                }
              } else {
                this.testBankObj.boxes = [
                  { id: 0, nm: "Уг хичээлд шалгалт үүсгээгүй байна" },
                ];
              }
            }
          }
        });
      } else {
        this.testBankObj.boxes = [];
      }
    },
    postTestBank() {
      let newExamId = null;
      let newSectionId = null;

      //# shine hicheeliin shalgalt vvsgeh
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Form/PostForm" },
        data: {
          flag: 500,
          name:
            this.moreData.title +
            " - " +
            moment(new Date()).format("YY-MM-DD HH:mm"),
          integrationCode: null,
          locTypeId: this.testBankObj.locTypeId,
          info: null,
          startDate: null,
          endDate: null,
          questionShuffle: -1,
          answerShuffle: 0,
          attemptCount: 100,
          minute: 20,
          ord: 1,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          newExamId = res.data.formId;
          newSectionId = res.data.sectionId;

          //# vvssen shalgalt aa hicheeliin shalgalt hairtsagt holboj baina
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            data: { boxId: this.testBankObj.boxId, formId: newExamId },
            api: { method: "POST", url: "Box/AttachForm" },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //# form doo asuultuud vvsgej baina
              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "post", url: "v2/Form/PostQuestionPack" },
                //data: this.questionModel,
                data: {
                  formId: newExamId,
                  sectionId: newSectionId,
                  libraryId: this.id,
                  count: this.moreData.questionData.questions.filter(
                    (x) => x.answerTypeId != 1 && x.answerTypeId != 11
                  ).length,
                  point: 100,
                  locTypeId: this.testBankObj.locTypeId,
                },
                store: this.$store,
              }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  this.$router.push({
                    name: "examOnline",
                    params: {
                      courseId: this.testBankObj.courseId,
                      formId: newExamId,
                      lessonId: this.testBankObj.lessonId,
                      boxId: this.testBankObj.boxId,
                      boxOt: 416,
                    },
                  });
                }
              });
            }
          });
        }
      });
    },
  },

  computed: {
    formId() {
      return this.id;
    },
  },
  watch: {
    formId(val) {
      if (val > 0) {
        this.init();
      }
    },
  },
};
</script>
